import http from "./httpService";

import { default as apiConfing } from "../config.json";
import { AxiosResponse } from "axios";
import { TagProps } from "../typings/tag";

const apiUrl = apiConfing.IS_DEVELOPMENT
  ? apiConfing.API_DEVELOPMENT
  : apiConfing.API_PRODUCTION;

const apiEndpoint = `${apiUrl}/Search`;

export function getTagsPool(): Promise<AxiosResponse<TagProps>> {
  const url = `${apiEndpoint}/GetTagsPool`;
  return http.get(url);
}

//TODO: Once you know what's the response, then change the any type!
export function getUsersBySearch(
  cityId: number | undefined,
  username: string,
  selectedTagsIds: string
): Promise<any> {
  console.log("getUsersBySearch cityId: ", cityId);
  console.log("getUsersBySearch userName: ", username);
  console.log("getUsersBySearch selectedTagsIds: ", selectedTagsIds);

  const url = `${apiEndpoint}/GetUsersBySearch`;
  return http.post(url, {
    cityId,
    username,
    selectedTagsIds,
  });
}
